function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M60.035,31.035h-4.06c-0.233-5.861-2.575-11.188-6.29-15.24l2.875-2.875l2.829,2.829l1.414-1.414l-7.071-7.071l-1.414,1.414  l2.829,2.829l-2.874,2.874C44.221,10.635,38.881,8.268,33,8.025V4h4V2H27v2h4v4.025c-5.866,0.242-11.194,2.597-15.242,6.325  l-2.844-2.844l2.829-2.829l-1.414-1.414l-7.071,7.071l1.414,1.414l2.829-2.829l2.845,2.845C10.619,19.812,8.267,25.138,8.025,31H4  v-4H2v10h2v-4h4.025c0.242,5.869,2.599,11.199,6.33,15.248l-2.857,2.857L8.67,48.276L7.256,49.69l7.071,7.071l1.414-1.414  l-2.829-2.829l2.857-2.857c4.047,3.722,9.37,6.072,15.23,6.313V60h-4v2h10v-2h-4v-4.025c5.862-0.242,11.188-2.594,15.235-6.318  l2.862,2.862l-2.829,2.829l1.414,1.414l7.071-7.071l-1.414-1.414l-2.829,2.829l-2.862-2.862c3.721-4.04,6.075-9.355,6.325-15.207  h4.061v4h2v-10h-2V31.035z M32,54c-12.131,0-22-9.869-22-22s9.869-22,22-22s22,9.869,22,22S44.131,54,32,54z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M32,27c-2.757,0-5,2.243-5,5s2.243,5,5,5s5-2.243,5-5S34.757,27,32,27z M32,35c-1.654,0-3-1.346-3-3s1.346-3,3-3  s3,1.346,3,3S33.654,35,32,35z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M32,12c-2.804,0-5,1.538-5,3.5c0,1.722,1.691,3.115,4,3.431V21h2v-2.069c2.309-0.316,4-1.71,4-3.431  C37,13.538,34.804,12,32,12z M32,17c-1.717,0-3-0.792-3-1.5s1.283-1.5,3-1.5s3,0.792,3,1.5S33.717,17,32,17z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M33,45.069V43h-2v2.069c-2.309,0.316-4,1.71-4,3.431c0,1.962,2.196,3.5,5,3.5s5-1.538,5-3.5  C37,46.778,35.309,45.385,33,45.069z M32,50c-1.717,0-3-0.792-3-1.5s1.283-1.5,3-1.5s3,0.792,3,1.5S33.717,50,32,50z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M18.931,33H21v-2h-2.069c-0.316-2.309-1.71-4-3.431-4c-1.962,0-3.5,2.196-3.5,5s1.538,5,3.5,5  C17.222,37,18.615,35.309,18.931,33z M15.5,35c-0.708,0-1.5-1.283-1.5-3s0.792-3,1.5-3s1.5,1.283,1.5,3S16.208,35,15.5,35z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M45.069,31H43v2h2.069c0.316,2.309,1.71,4,3.431,4c1.962,0,3.5-2.196,3.5-5s-1.538-5-3.5-5  C46.778,27,45.385,28.691,45.069,31z M48.5,29c0.708,0,1.5,1.283,1.5,3s-0.792,3-1.5,3S47,33.717,47,32S47.792,29,48.5,29z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M24.557,19.808c0.277-1.199,0.026-2.296-0.688-3.01c0,0,0,0,0,0s0,0,0,0c-0.714-0.714-1.811-0.965-3.01-0.688  c-1.048,0.242-2.114,0.863-3,1.75s-1.508,1.952-1.75,3c-0.277,1.199-0.025,2.296,0.688,3.01c0.524,0.524,1.254,0.799,2.08,0.799  c0.299,0,0.612-0.036,0.931-0.11c0.764-0.176,1.536-0.559,2.242-1.094l1.465,1.465l1.414-1.414l-1.465-1.465  C23.999,21.343,24.381,20.572,24.557,19.808z M19.358,22.608c-0.513,0.118-0.93,0.063-1.146-0.155  c-0.216-0.216-0.272-0.634-0.154-1.146c0.156-0.678,0.599-1.42,1.215-2.036s1.358-1.059,2.036-1.215  c0.176-0.041,0.341-0.061,0.49-0.061c0.286,0,0.514,0.073,0.656,0.215c0,0,0,0,0,0c0.216,0.216,0.272,0.634,0.154,1.146  c-0.156,0.678-0.599,1.42-1.215,2.036S20.036,22.452,19.358,22.608z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M44.192,39.443c-0.764,0.176-1.536,0.558-2.242,1.094l-1.465-1.465l-1.414,1.414l1.465,1.465  c-0.535,0.706-0.918,1.478-1.094,2.242c-0.277,1.199-0.026,2.296,0.688,3.01c0,0,0,0,0,0s0,0,0,0  c0.524,0.524,1.254,0.798,2.079,0.798c0.299,0,0.612-0.036,0.931-0.11c1.048-0.242,2.114-0.863,3-1.75s1.508-1.952,1.75-3  c0.277-1.199,0.025-2.296-0.688-3.01C46.489,39.417,45.392,39.166,44.192,39.443z M45.943,42.692  c-0.156,0.678-0.599,1.42-1.215,2.036s-1.358,1.059-2.036,1.215c-0.514,0.119-0.931,0.062-1.146-0.154c0,0,0,0,0,0  c-0.216-0.216-0.272-0.634-0.154-1.146c0.156-0.678,0.599-1.42,1.215-2.036s1.358-1.059,2.036-1.215  c0.176-0.041,0.341-0.061,0.49-0.061c0.286,0,0.514,0.073,0.656,0.215C46.005,41.762,46.061,42.18,45.943,42.692z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M23.515,39.071l-1.465,1.465c-0.706-0.535-1.478-0.917-2.242-1.094c-1.199-0.276-2.296-0.026-3.01,0.688c0,0,0,0,0,0  s0,0,0,0c-0.714,0.714-0.965,1.812-0.688,3.01c0.242,1.048,0.863,2.114,1.75,3s1.952,1.508,3,1.75  c0.319,0.074,0.631,0.11,0.931,0.11c0.825,0,1.555-0.274,2.079-0.798c0.714-0.714,0.966-1.812,0.689-3.011  c-0.176-0.764-0.558-1.536-1.094-2.242l1.465-1.465L23.515,39.071z M22.454,45.789c-0.215,0.216-0.632,0.272-1.146,0.154  c-0.678-0.156-1.42-0.599-2.036-1.215s-1.059-1.358-1.215-2.036c-0.118-0.512-0.062-0.93,0.154-1.146c0,0,0,0,0,0  c0.142-0.142,0.37-0.215,0.656-0.215c0.149,0,0.314,0.02,0.49,0.061c0.678,0.156,1.42,0.599,2.036,1.215s1.059,1.358,1.215,2.036  C22.727,45.154,22.67,45.572,22.454,45.789z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M43.142,16.108c-1.198-0.277-2.295-0.026-3.01,0.688c-0.714,0.714-0.966,1.812-0.689,3.011  c0.176,0.764,0.559,1.536,1.094,2.242l-1.465,1.465l1.414,1.414l1.465-1.465c0.706,0.535,1.478,0.918,2.242,1.094  c0.319,0.074,0.631,0.11,0.931,0.11c0.825,0,1.555-0.274,2.079-0.798c0,0,0,0,0,0s0,0,0,0c0.714-0.714,0.965-1.812,0.688-3.01  c-0.242-1.048-0.863-2.114-1.75-3S44.19,16.35,43.142,16.108z M45.789,22.454C45.789,22.454,45.789,22.454,45.789,22.454  c-0.216,0.217-0.633,0.272-1.146,0.155c-0.678-0.156-1.42-0.599-2.036-1.215s-1.059-1.358-1.215-2.036  c-0.118-0.512-0.062-0.93,0.155-1.146c0.142-0.142,0.37-0.215,0.656-0.215c0.149,0,0.314,0.02,0.49,0.061  c0.678,0.156,1.42,0.599,2.036,1.215s1.059,1.358,1.215,2.036C46.061,21.82,46.005,22.238,45.789,22.454z"
});

var SvgCorona = function SvgCorona(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1_1_",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M32,9c-6.353,0-12.105,2.576-16.267,6.74C11.573,19.902,9,25.651,9,32c0,12.703,10.297,23,23,23  s23-10.297,23-23C55,19.297,44.703,9,32,9z M40.839,17.504c0.976-0.976,3.034-0.501,4.596,1.061c1.562,1.562,2.037,3.62,1.061,4.596  s-3.034,0.501-4.596-1.061C40.337,20.538,39.863,18.481,40.839,17.504z M18.565,18.565c1.562-1.562,3.62-2.037,4.596-1.061  c0.976,0.976,0.501,3.034-1.061,4.596c-1.562,1.562-3.62,2.037-4.596,1.061S17.003,20.127,18.565,18.565z M15.5,36  c-1.381,0-2.5-1.791-2.5-4c0-2.209,1.119-4,2.5-4s2.5,1.791,2.5,4C18,34.209,16.881,36,15.5,36z M23.161,46.496  c-0.976,0.976-3.034,0.501-4.596-1.061c-1.562-1.562-2.037-3.62-1.061-4.596s3.034-0.501,4.596,1.061  C23.663,43.462,24.137,45.519,23.161,46.496z M32,51c-2.209,0-4-1.119-4-2.5c0-1.381,1.791-2.5,4-2.5s4,1.119,4,2.5  C36,49.881,34.209,51,32,51z M32,36c-2.209,0-4-1.791-4-4c0-2.209,1.791-4,4-4s4,1.791,4,4C36,34.209,34.209,36,32,36z M32,18  c-2.209,0-4-1.119-4-2.5c0-1.381,1.791-2.5,4-2.5s4,1.119,4,2.5C36,16.881,34.209,18,32,18z M45.435,45.435  c-1.562,1.562-3.62,2.037-4.596,1.061c-0.976-0.976-0.501-3.034,1.061-4.596c1.562-1.562,3.62-2.037,4.596-1.061  S46.997,43.873,45.435,45.435z M48.5,36c-1.381,0-2.5-1.791-2.5-4c0-2.209,1.119-4,2.5-4s2.5,1.791,2.5,4  C51,34.209,49.881,36,48.5,36z",
    style: {
      fill: "#D64528"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 4,
    style: {
      fill: "#ED5D40"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 15.5,
    rx: 4,
    ry: 2.5,
    style: {
      fill: "#ED5D40"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 48.5,
    rx: 4,
    ry: 2.5,
    style: {
      fill: "#ED5D40"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.5,
    cy: 32,
    rx: 2.5,
    ry: 4,
    style: {
      fill: "#ED5D40"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.5,
    cy: 32,
    rx: 2.5,
    ry: 4,
    style: {
      fill: "#ED5D40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.101,22.1c1.562-1.562,2.037-3.62,1.061-4.596c-0.976-0.976-3.034-0.501-4.596,1.061  c-1.562,1.562-2.037,3.62-1.061,4.596S20.538,23.663,22.101,22.1z",
    style: {
      fill: "#ED5D40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.839,46.496c0.976,0.976,3.034,0.501,4.596-1.061c1.562-1.562,2.037-3.62,1.061-4.596  s-3.034-0.501-4.596,1.061C40.337,43.462,39.863,45.519,40.839,46.496z",
    style: {
      fill: "#ED5D40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.504,40.839c-0.976,0.976-0.501,3.034,1.061,4.596c1.562,1.562,3.62,2.037,4.596,1.061  c0.976-0.976,0.501-3.034-1.061-4.596C20.538,40.337,18.481,39.862,17.504,40.839z",
    style: {
      fill: "#ED5D40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.496,23.161c0.976-0.976,0.501-3.034-1.061-4.596c-1.562-1.562-3.62-2.037-4.596-1.061  c-0.976,0.976-0.501,3.034,1.061,4.596C43.462,23.663,45.519,24.137,46.496,23.161z",
    style: {
      fill: "#ED5D40"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,51c-12.028,0-21.894-9.235-22.908-21C9.035,30.66,9,31.326,9,32c0,12.703,10.297,23,23,23  s23-10.297,23-23c0-0.674-0.035-1.34-0.092-2C53.894,41.765,44.028,51,32,51z",
    style: {
      fill: "#C43F25"
    }
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCorona, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/corona.2137ff09.svg";
export { ForwardRef as ReactComponent };